module.exports = __webpack_public_path__ + "img/spell_prism.551fdcf5.png";